import React from 'react';
import BlogList from '../components/BlogList';
const Blogs = ()=>{
    return(
    <>
       <BlogList />
    </>
    );
}

export default Blogs;